export default __webpack_public_path__ + "static/media/disco_ball@3x.440f9ed5.png";